import gql from 'graphql-tag';

export const CHANGE_EVENT_ANSWER_FRAGMENT = gql`
  fragment changeEventAnswer on Answer {
    id
    body
    publishedAt
    user {
      id
      name
      picture
      email
      jobTitle
    }
    question {
      id
      permalink
      text
      plex {
        id
        name
        currentUserRelation {
          id
          state
        }
      }
    }
    currentUserRelation
    deleted
  }
`;
